import { Authority } from "@skinsoft/types"
import { dbCacheDown } from "../dexie/cache-down"
import { STATS_KEYS } from "../dexie/stats-keys"
import { OfflineDataFetcher } from "@skinsoft/offline"

export class AuthorityOfflineDataFetcher extends OfflineDataFetcher<Authority> {
    constructor() {
        super(dbCacheDown.authority, STATS_KEYS.authority)
    }
}